<div class="header fx-row fx-justify-space-between fx-items-center">
  <div class="description fx-row fx-justify-start fx-items-center" style="gap: 12px">
    @if (datasetRS.record.value) {
      <button class="back" mat-icon-button (click)="datasetRS.record.next(null);">
        <mat-icon>arrow_back_ios</mat-icon>
      </button>
    }
    <span class="material-icons-outlined">directions_bus_filled</span>
    @if (!datasetRS.record.value) {
      <span class="label">{{'Risorse' | translate}}</span>
    }
    @if (datasetRS.record.value) {
      <span class="label">{{ datasetRS.record.value.trip_resource.full_description || datasetRS.record.value.trip_resource.description }}</span>
    }
  </div>

  <div class="close-icon fx-row fx-justify-end fx-items-center">
    <span class="material-icons-outlined dialog-close-icon" (click)="onCloseClick()">close</span>
  </div>
</div>

<div class="trip-booking-resource-container">
  @if (!datasetRS.record.value) {
    @for (bookingPackage of data.tripBookingPackages; track bookingPackage) {
      <div class="actual_trip fx-row fx-justify-start fx-items-center" style="gap: 8px">
        @if (bookingPackage.actual_trip.type) {
          @if (["going", "single"].includes(bookingPackage.actual_trip.type)) {
            <span class="going_trip">
              <img src="assets/icons/material-icons/filled/going_trip_icon.svg" />
            </span>
          }
          @if (["return"].includes(bookingPackage.actual_trip.type)) {
            <span class="return_trip">
              <img src="assets/icons/material-icons/filled/return_trip_icon.svg" />
            </span>
          }
        }
        <span class="display_name">{{ bookingPackage.actual_trip.display_name }}</span>
        <span class="date">{{ bookingPackage.actual_trip.start_day | date:'dd/MM/yyyy' }}</span>
        @if (bookingPackage.actual_trip.start_time) {
          <span class="hour">{{ bookingPackage.actual_trip.start_time }}</span>
        }
      </div>
      <!-- trip_booking_resources by trip_booking_package -->
      <dataset-list
        [enableCreate]='data.bookingService.canEdit'
        [elevate]='false'
        [showSearchBar]='false'
        [showTitle]='false'
        datasetCode='trip_booking_resources'
        [parentDatasetACS]='data.tripBookingPackageACS'
        [parentDatasetRS]='data.tripBookingPackageRS'
        [filters]='{ trip_booking_package_id: bookingPackage.id }'
        [selectable]='true'
        (selected)='onSelected($event)'
        tableStyle="style-1"
      ></dataset-list>
    }
  }

  @if (datasetRS.record.value) {
    <div class="trip_booking_resource_services" style="padding: 24px;">
      <dataset-list
        [enableCreate]='data.bookingService.canEdit && datasetRS.record.value.optional == 1'
        [elevate]='false'
        [showSearchBar]='false'
        [showTitle]='false'
        datasetCode='trip_booking_services'
        [parentDatasetACS]='datasetACS'
        [parentDatasetRS]='datasetRS'
        [filters]='{ trip_booking_resource_id: datasetRS.recordId }'
        tableStyle="style-1"
      ></dataset-list>
    </div>
  }
</div>

<!-- footer -->
<div class="footer"></div>